import React from 'react'
import moment from 'moment'
import { Link, } from 'react-router-dom'
import { Popover, Switch, message } from 'antd'
import { editTagBrand } from '../../../../services/api/apiBrands'
import { canViewStoreName } from '../../../../services/StorageServices'


const TableRow = ({ item, reset }) => {
    const canViewStore = canViewStoreName()
    const { brands, type, name, created_at, updated_at, design, quantity, base_cost, fee, note, _id, material_code, description, is_active } = item

    const content = (
        <div>
            <span>{note}</span>
        </div>
    )
    const contentDescription = (
        <div>
            <span>{description}</span>
        </div>
    )
    const handleChangeStatus = async(id, isActive) => {
        try {
            const payload = {is_active: !isActive}
            const { data: res } = await editTagBrand(id, payload)
            const {success, message: mess} = {...res}
            if(!success) {
                throw new Error(mess)
            }
            message.success(`Tag Brand change status success!`)
            reset()
        } catch (error) {
            message.error(error.message)
        }
    }
    return (
        <tr className={`TableRow ${+quantity <= 100 ? 'WarningQuantity' : ''}`}>
            {canViewStore && <td className="Store">
                <div>{brands[0].store || '-'}</div>
                <div>{brands[0].name || '-'}</div>
            </td>}
            <td className="BrandType text-capitalize">{type || '-'}</td>
            <td>{material_code || '-'}</td>
            <td className="BrandDetail">
                <div className="NameDetail">
                    {name || '-'}
                </div>
                {
                    design && <div className="LinkDesign" target="_blank">
                        <a href={design} target="_blank">
                            Link design
                        </a>
                    </div>
                }
            </td>
            <td className="Quantity">{quantity || '-'}</td>
            <td className="Cost">
                <div className="BaseCost font-weight-bold">
                    {base_cost || '-'}
                </div>
                <div className={`Fee ${fee && 'text-danger'} font-weight-bold`}>
                    {fee || '-'}
                </div>
            </td>
            <td>
                {!!description && description.length > 20 ?
                    <Popover
                        content={contentDescription}
                        title="Description"
                        overlayClassName='DescriptionPopover'
                    >
                        {`${description.substring(0, 20)}...`}
                    </Popover> : (description || '')
                }
            </td>
            <td className="Note">
                {
                    !!note && note.length > 20 ? <Popover content={content} title="Note" overlayClassName='NotePopover'>{`${note.substring(0, 20)}...`}</Popover> : (note || '')
                }
            </td>
            <td>
                <Switch title='Change status' key={_id} checked={is_active} onClick={()=>handleChangeStatus(_id,is_active)}/>
            </td>
            <td className="Time">
                <div>{moment(created_at).format("hh:mm DD/MM/YYYY")}</div>
                <div>{moment(updated_at).format("hh:mm DD/MM/YYYY")}</div>
            </td>
            <td className="Action">
                <Link to={`/tag-brand-edit/${item._id}`}>Edit</Link>
            </td>
        </tr>
    )
}

export default TableRow
